
const User = (state = { user: {}, paymentMethod: {}, settings: {}, haveAccess: true, defaultLang:'fr', id:'', token:'', dateFormat: 'DD/MM/YYYY', dateTimeFormat: 'DD/MM/YYYY HH:mm', isLoaded: false }, action) => {

  switch(action.type) {

    case  'LOAD_USER_INFO':
      return state;
    case 'SET_USER_INFO':
      return {
        ...state,
        user: action.user,
        paymentMethod: action.paymentMethod,
      }
      case 'SET_AUTH_USER_INFO':
        return {
          ...state,
          id:action.id,
          token: action.token
        }
      case 'SET_DFAULT_LANGUAGE':
      return {
        ...state,
        defaultLang: action.defaultLang
      }
    case 'SET_ACCESS_RIGHT':
      return {
        ...state,
        haveAccess: action.haveAccess
      }
      case 'SET_DATE_DISPLAY':
      return {
        ...state,
        dateFormat: action.dateFormat
      };
      case 'LOAD_SERVICES_INFO':
      return {
        ...state,
        isLoaded: action.isLoaded
      }
    default:
      return state;
  }
};

export default User;



// WEBPACK FOOTER //
// ./src/reducers/UserReducer.js